import type { TOrgInfo } from "@/types";

export const loaderGlobalData = ({ orgInfo }: { orgInfo: TOrgInfo }) => {
  const hideHeaderBadge = orgInfo?.hideHeaderBadge;
  const logo = orgInfo?.customization?.logo;

  return `
    <script>
      window['loader-n7FEhFPpZGvUY9Z'] = {
        hideHeaderBadge: ${hideHeaderBadge},
        logo: '${logo || ""}',
      };
    </script>
  `;
};
